import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import CustomInput from '../../atoms/Inputs/CustomInput'
import PrimaryButton from '../../atoms/PrimaryButton'
import RadioBox from '../../atoms/RadioBox'
import axiosmethod from 'axios'
import payAmountStripe from '../../../Utils/API/payamountstripe'
import axiosInstance from '../../../Utils/Utility/axiosconfig'
import './CheckoutPayment.css'
import Swal from 'sweetalert2'
import listpayment from '../../../Utils/API/selectcardpayment'
import getShippingAmount from '../../../Utils/API/shipstation'

const CheckoutPayment = (props) => {
    const history = useHistory()
    console.log('checkout propes --------', props)
    const [radvalue, setValue] = useState(false)
    const [selectedCard, setSelectedCard] = useState([])
    const [cardNumber, setCardNumber] = useState('')
    const [expMonth, setExpMonth] = useState('')
    const [expYear, setExpYear] = useState('')
    const [cardCvv, setCardCvv] = useState('')
    const [cardName, setCardName] = useState('')
    const [oldCard, setOldCard] = useState(0)
    const [cartTotal, setCartTotal] = useState(0)
    const [shipAmt, setShipAmt] = useState(0)
    const [loading, setLoading] = useState(true)

    // setCartTotal(
    //     parseFloat(props.additional_amount_1) +
    //         parseFloat(props.additional_amount_2) +
    //         parseFloat(props.additional_amount_3),
    // )

    const listedcardPayment = async (data) => {
        const det = await listpayment(data, props.inv)
        console.log(det, 'resres')
        if (det === true) {
            Swal.fire({
                title: 'Successfully paid',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            history.push({
                pathname: '/dashboard',
                state: {
                    value: 1,
                },
            })
        } else {
            Swal.fire({
                title: 'Try Again later.',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
        }
    }

    useEffect(() => {
        allsavedCards()
        if (props.profile.zip) {
            shippingAmount()
        } else {
            setLoading(false)
        }
    }, [])

    const shippingAmount = async () => {
        let params = {
            mode: 'sandbox', //process.env.REACT_APP_PAYMENT_MODE,
            fromzipcode: '98684',
            zipcode: props.profile.zip,
            weight: 10,
            height: 10,
        }
        const res = await getShippingAmount(params)
        console.log('getShippingAmount', params, res)
        setShipAmt(res.data.ship_rate)
        setLoading(false)
    }

    const allsavedCards = async () => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const cardID = userData.card_paymentid
        let body = {
            account_id: process.env.REACT_APP_AUCTIONPAYKEY,
            customer_id: cardID,
        }
        const { data } = await axiosmethod.post(
            `https://paymentapi.auctionsoftware.com/api/customer/source/list`,
            body,
        )
        try {
            if (data.status === 'success') {
                console.log('data.responseData.data ', data.data.responseData.data)
                data.data.responseData.data && setSelectedCard(data.data.responseData.data)
                // data.selectedCard && setSelected(data.selectedCard)
            } else {
                setSelectedCard([])
            }
        } catch (err) {
            console.log(err)
        }
    }
    // const savedCards = [
    //     { id: 1, cardNumber: '4132 1231 3212 2135', dateExp: '12/20', cardName: 'MasterCard' },
    //     { id: 2, cardNumber: '4132 1231 3212 2135', dateExp: '12/20', cardName: 'MasterCard' },
    // ]

    const handleChangeRadio = (event) => {
        console.log('event ==============', event.target.value)
        setValue(event.target.value)
    }
    const paynow = async () => {
        if (oldCard === 0) {
            let body = {
                account_id: process.env.REACT_APP_AUCTIONPAYKEY,
                card_number: cardNumber,
                // card_name: cardName,
                card_cvc: cardCvv,
                card_exp_month: expMonth,
                card_exp_year: expYear,
                // mode: 'sandbox',
                card_token: true,
                amount:
                    parseFloat(props.totalPrice) +
                    parseFloat(props.additional_amount_1) +
                    parseFloat(props.additional_amount_2) +
                    parseFloat(props.additional_amount_3),
                // isSave: true,
                currency: 'usd',
                payDirect: 1,
                description: props.name,
            }
            const resData = await payAmountStripe(body)

            if (resData.data.status === 'success') {
                let bodyParams = {
                    buyerPremiumTotal: 1,
                    inv: props.inv,
                    mode: 'sandbox',
                    payamt:
                        parseFloat(props.totalPrice) +
                        parseFloat(props.additional_amount_1) +
                        parseFloat(props.additional_amount_2) +
                        parseFloat(props.additional_amount_3),
                    totalInvoice:
                        parseFloat(props.totalPrice) +
                        parseFloat(props.additional_amount_1) +
                        parseFloat(props.additional_amount_2) +
                        parseFloat(props.additional_amount_3),
                    trans_gateway: 'Card Payment',
                    transaction_id: resData.data.data.responseData.id,
                    shipAmt: parseFloat(shipAmt),
                    shipCmb: '0.00',
                    shipOrg: '0.00',
                    // salesAmt: auctionDetails.getax_total,
                    // persale: auctionDetails.orgsalesPercen,
                }
                // const PaymentEntryData = await successAfterPay(bodyParams)
                const res = await axiosInstance.post('mobileapi/successGroupInvoice', bodyParams)
                Swal.fire({
                    title: 'Successfully paid',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                history.push({
                    pathname: '/dashboard',
                    state: {
                        value: 1,
                    },
                })
                // props.upd()
                // setmodalOpen(false)
            } else {
                Swal.fire({
                    title: 'Try Again later.',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        }
    }
    return (
        <div className="paymentDetails">
            <div className="paymentTotal">
                <div className="won_amount d-flex justify-content-between">
                    <p className="totalTitle">won amount</p>
                    <p className="won_amount">: ${props.totalPrice}</p>
                </div>
                <div className="admin_amount_1 d-flex justify-content-between">
                    <p className="totalTitle">Admin added amount</p>
                    <p className="additional_amount_1">: ${props.additional_amount_1}</p>
                </div>
                <div className="admin_amount_2 d-flex justify-content-between">
                    <p className="totalTitle">Handling charges</p>
                    <p className="additional_amount_2">: ${props.additional_amount_2}</p>
                </div>
                <div className="admin_amount_3 d-flex justify-content-between">
                    <p className="totalTitle">Additional charge</p>
                    <p className="additional_amount_3">: ${props.additional_amount_3}</p>
                </div>
                <div className="admin_amount_3 d-flex justify-content-between">
                    <p className="totalTitle">Shipping Amount</p>
                    <p className="additional_amount_3">: ${loading ? '' : shipAmt}</p>
                </div>
                <div className="totalAmount d-flex justify-content-between">
                    <p className="totalTitle">TotalAmount</p>
                    <p className="totalPrice">
                        : $
                        {loading
                            ? ''
                            : parseFloat(
                                  parseFloat(props.totalPrice) +
                                      parseFloat(props.additional_amount_1) +
                                      parseFloat(props.additional_amount_2) +
                                      parseFloat(props.additional_amount_3) +
                                      parseFloat(shipAmt),
                              ).toFixed(2)}
                    </p>
                </div>
                {/* <div className="convenienceAmount d-flex justify-content-between">
                        <p className="convenienceTitle">Convenience Fee 3%</p>
                        <p className="convenienceFee">:{props.conFee}</p>
                    </div>
                    <div className="taxAmount d-flex justify-content-between">
                        <p className="taxTitle">Tax 0%</p>
                        <p className="taxPrice">:{props.taxPrice}</p>
                    </div>
                    <div className="grandTotal d-flex justify-content-between">
                        <p className="grandTitle">GrandTotal</p>
                        <p className="grandPrice">:{props.grandTotal}</p>
                    </div> */}
            </div>
            <div className="paymentCard">
                <div className="exsitingCard">
                    <div className="numRadio">
                        <RadioBox
                            items={selectedCard}
                            value={radvalue}
                            onchange={handleChangeRadio}
                            name="savedcards"
                            int={1}
                            checkout={true}
                            cc={listedcardPayment}
                        />
                        {/* {console.log(radvalue, 'radvalueeeeeeeeeee')} */}
                    </div>
                </div>
                <div className="cardText">
                    <CustomInput
                        label="Card Number"
                        variant="standard"
                        value={cardNumber}
                        name="cardnumber"
                        inputProps={{ maxLength: 16 }}
                        onChange={(e) => {
                            setCardNumber(e.target.value)
                        }}
                    />
                    <CustomInput
                        label="Name on the Card"
                        value={cardName}
                        variant="standard"
                        onChange={(e) => {
                            setCardName(e.target.value)
                        }}
                    />
                    <div className="cardExpiry d-flex justify-content-between ">
                        <CustomInput
                            label="Expiry Month"
                            value={expMonth}
                            variant="standard"
                            inputProps={{ maxLength: 2 }}
                            onChange={(e) => {
                                setExpMonth(e.target.value)
                            }}
                        />
                        <CustomInput
                            label="Expiry Year"
                            value={expYear}
                            variant="standard"
                            inputProps={{ maxLength: 4 }}
                            onChange={(e) => {
                                setExpYear(e.target.value)
                            }}
                        />
                    </div>
                    <CustomInput
                        label="CVV"
                        value={cardCvv}
                        variant="standard"
                        inputProps={{ maxLength: 3 }}
                        onChange={(e) => {
                            setCardCvv(e.target.value)
                        }}
                    />
                </div>
                {loading ? '' : <PrimaryButton label="Pay" onClick={paynow} />}
            </div>
        </div>
    )
}

export default CheckoutPayment
